import Template from 'frontools/data/Template';
import ComponentAbstract from './ComponentAbstract';
import { autobind } from 'frontools/decorators/Autobind';
import GameAbstract from '../GameAbstract';
import { GameEvent } from '../GameAbstract';
import { Assets } from '../Assets';

export class Countdown extends ComponentAbstract {

    private _time               : number                    = 2;
    private _current            : number                    = 0;
    private _elNumber           : HTMLElement;

    constructor(time: number) {
        super();

        this._time = time;        
        
        let tpl = new Template(document.querySelector('#tplCountdown') as HTMLElement, {}).htmlAsDOM.firstElementChild as HTMLElement;
        this._elComponent = tpl as HTMLElement;
        GameAbstract.elGameWrapper.appendChild(this._elComponent);
        this._elNumber = GameAbstract.elGameWrapper.querySelector('[data-js="number"]') as HTMLElement;

        this._count();
    }

    /*
     * _count - Iterates through the countdown
     * @param {Object} data - game data
     * 
     */
    private _count() {
        if (this._time > this._current) {
            var timeLeft = this._time - this._current;
            this._render(timeLeft);
            
            // We only have 3 sounds for the countdown, it if's set as higher than 2, there won't be any sounds for anything above
            if (timeLeft < 3) {
                Assets.sounds['countdown'+ timeLeft].play();
            }

            this._current++;
            setTimeout(this._count.bind(this), 1000);
        } else {
            Assets.sounds['countdown0'].play();
            this._onEnded();
        }
    };


    /*
     * _render - Countdown end handler
     * @param {number} time - current time to render
     * 
     */
    @autobind
    private _render(time: number) {
        TweenMax.set(this._elNumber, {scale: 2, alpha: 0});
        this._elNumber.innerText = String(time);
        TweenMax.to(this._elNumber, .3, {scale: 1, alpha: 1, ease: Expo.easeOut});
    };


    /*
     * _onEnded - Countdown end handler
     * 
     */
    @autobind
    private _onEnded() {
        this.dispatch({type: CountdownEvent.COMPLETE});
        this.destroy();
    };



    /*
     * destroy - destroy this instance
     * 
     */
    public destroy() {
        super.destroy();
    };



    /*
     * _resize - handle resize
     * 
     */
    protected _resize(e) {
        super._resize(e);
    };

}

export class CountdownEvent {
    public static COMPLETE              : string                = 'complete';
}